/* Payal Jewellers — Hero fade carousel.
   Cross-fades background slides on an interval; infinite loop, no controls.
   Each slide can carry its own text box ([data-slide-content]) which is toggled
   in sync with the active image. Respects reduced-motion, pauses when the tab is
   hidden, guarded define. */
if (!customElements.get('hero-carousel')) {
  customElements.define(
    'hero-carousel',
    class HeroCarousel extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.hero-banner__slide'));
        var root = this.closest('.hero-banner');
        this.contentBoxes = root ? Array.from(root.querySelectorAll('[data-slide-content]')) : [];
        this.index = 0;
        this.interval = parseInt(this.dataset.interval, 10) || 5000;

        if (this.slides.length < 2) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        this.start();
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) {
            this.stop();
          } else {
            this.start();
          }
        });
      }

      start() {
        this.stop();
        this.timer = setInterval(() => this.next(), this.interval);
      }

      stop() {
        if (this.timer) clearInterval(this.timer);
      }

      setActive(i, on) {
        if (this.slides[i]) this.slides[i].classList.toggle('is-active', on);
        if (this.contentBoxes[i]) this.contentBoxes[i].classList.toggle('is-active', on);
      }

      next() {
        this.setActive(this.index, false);
        this.index = (this.index + 1) % this.slides.length;
        this.setActive(this.index, true);
      }

      disconnectedCallback() {
        this.stop();
      }
    }
  );
}
